/* eslint-disable no-unused-vars */
import { useSelector, useDispatch } from 'react-redux';
import { reportsActions } from 'store/actions';
import { DateRange } from 'components';

export const ReportsCalendar = () => {
  const dispatch = useDispatch();

  const timePeriod = useSelector((state) => state.reports.selectedDateRangeReports);
  const dateRangeName = useSelector((state) => state.reports.dateRangeNameReports);

  function updateRangeName(rangeName) {
    dispatch(reportsActions.updateDateRangeName(rangeName));
  }

  function updateTimeRange(fromDate, toDate) {
    dispatch(reportsActions.updateTimeRange({ from: fromDate, to: toDate }));
  }

  return (
    <DateRange
      dateFrom={timePeriod.from}
      dateTo={timePeriod.to}
      dateRangeName={dateRangeName}
      onUpdateRangeName={updateRangeName}
      onUpdateTimeRange={updateTimeRange}
    />
  );
};
